import routerOptions0 from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/node_modules/.pnpm/nuxt@4.0.0_@vue+compiler-sfc@3.5.31_eslint@8.57.1_rollup@4.60.0_sass@1.98.0_typescript@5.9.3_vite@6.4.1/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}